// eslint-disable-next-line
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import FilterSelector from '@common/component/molecules/FilterSelector';
import { actions } from '@common/redux/modules/Actions';
import { filterConditionState } from '@common/redux/reducers/CurrentFilterReducer';
import { getFilterList } from '@common/redux/reducers/FilterListReducer';
import { LOADING_TYPE } from '@common/redux/reducers/LoadingStatusReducer';
import { AgencyAppState } from '../../../redux/modules/store';
import { SORRY_MESSAGE_TYPE } from '@common/redux/reducers/SorryMessageReducer';

const mapStateToProps = (appState: AgencyAppState) => {
  return {
    loadingStatus: appState.loadingStatus.conditions,
    currentFilter: appState.currentFilterCondition,
    filterList: appState.filterList,
    searchCondition: appState.SearchCondition,
    loginUser: appState.loginUser,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    clearFilter: () => {
      dispatch(actions.clearFilter());
    },
    updateCurrentFilter: (filterCondition: filterConditionState) => {
      dispatch(actions.updateCurrentFilter(filterCondition));
      dispatch(actions.updateSearchCondition(filterCondition.searchConditions));
    },
    fetchCustomFilter: (filterList: filterConditionState[], userId: string) => {
      if (filterList.length === 0) {
        dispatch(actions.updateLoadingStatus.started(LOADING_TYPE.CONDITIONS));
        getFilterList(userId).then((payload) => {
          dispatch(actions.filterList.update(payload));
          dispatch(actions.updateLoadingStatus.done({
            params: LOADING_TYPE.CONDITIONS
          }));
        }, (error) => {
          dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.SYSTEM_ERROR));
          dispatch(actions.updateLoadingStatus.failed({
            params: LOADING_TYPE.CONDITIONS,
            error
          }));
        });
      }
    },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(FilterSelector);
